import { Box, Button, Typography, useTheme } from "@mui/material";
import { useAuth } from "@sal/authentication.react";
import { getTerm, VerticalNavigationComponentProps } from "@sal/onevent-portal";
import AddIcon from "@mui/icons-material/Add";
import { routePermissionMapping } from "../appsettings";

export function VerticalNavigationActionButton({ collapsed }: VerticalNavigationComponentProps) {
	const auth = useAuth();
	const theme = useTheme();

	const hasFreightBookingPermission =
		auth.userHasPermission("apI_FreightConsignment", "Write") &&
		auth.userHasPermission("apI_ContainerConsignment", "Write");

	const hasContainerBookingPermission = (routePermissionMapping.order.permissions || []).some(
		([securityContext, permission]) => auth.userHasPermission(securityContext, permission)
	);

	if (!hasFreightBookingPermission && !hasContainerBookingPermission) {
		return null;
	}

	const buttonSx = {
		paddingY: collapsed ? theme.spacing(2) : theme.spacing(3),
		minWidth: collapsed ? "auto" : "initial"
	};

	return (
		<>
			<Box
				display="flex"
				flexDirection={"column"}
				alignItems="center"
				justifyContent="center"
				width="100%"
				paddingX={collapsed ? 0 : 6}
				paddingBottom={2}
				gap={4}
			>
				{hasFreightBookingPermission && (
					<Button
						variant="contained"
						color="secondary"
						fullWidth={!collapsed}
						title={getTerm("navigation_NewConsignment")}
						sx={buttonSx}
						onClick={() => (window.location.href = "/#/FreightBooking")}
					>
						<Typography
							fontSize={collapsed ? "large" : "0.85rem"}
							color={theme.palette.common.white}
							sx={{ display: "flex", alignItems: "center", gap: 1 }}
						>
							<AddIcon fontSize="inherit" />
							{!collapsed && <span>{getTerm("navigation_NewConsignment")}</span>}
						</Typography>
					</Button>
				)}
				{hasContainerBookingPermission && (
					<Button
						variant="contained"
						color="secondary"
						fullWidth={!collapsed}
						title={getTerm("navigation_NewOrder")}
						sx={buttonSx}
						onClick={() => (window.location.href = "/#/Order")}
					>
						<Typography
							fontSize={collapsed ? "large" : "0.85rem"}
							color={theme.palette.common.white}
							sx={{ display: "flex", alignItems: "center", gap: 1 }}
						>
							<AddIcon fontSize="inherit" />
							{!collapsed && <span>{getTerm("navigation_NewOrder")}</span>}
						</Typography>
					</Button>
				)}
			</Box>
		</>
	);
}
